'use client';

import { useI18n } from '@/components/i18n-provider';
import { getBlogArticles, getSiteContent } from '@/data/beshrmakki-content';

export function useContent() {
  const { locale } = useI18n();
  return getSiteContent(locale);
}

export function useBlogArticles() {
  const { locale } = useI18n();
  return getBlogArticles(locale);
}
